import { PropsWithChildren, useContext } from 'react';
import { Breadcrumbs, Page } from 'modules/app-shell/breadcrumbs';
import { twMerge } from 'tailwind-merge';
import { Button } from 'modules/shared-components/button/button';
import {
  ArrowTrendingUpIcon,
  BuildingLibraryIcon,
  ChevronRightIcon,
} from '@heroicons/react/24/outline';
import { SidebarContext } from '../Sidebar/context';
import config from 'config';
import SidebarSettings, {
  SidebarItem,
} from 'modules/shared-components/layout/Sidebar';

import {
  DexSwitchMode,
  useExchangeMode,
} from 'modules/DexSwitch/DexSwitchContext';

type Props = {
  pages?: Page[];
  sidebar?: boolean;
  toggle?: boolean;
  topRight?: JSX.Element;
  topLeft?: JSX.Element;
  className?: string;
};

const PageTemplate = ({
  pages,
  children,
  sidebar,
  topRight,
  topLeft,
  className,
}: PropsWithChildren<Props>) => {
  const { expanded, setExpanded } = useContext(SidebarContext);
  const { mode } = useExchangeMode();

  return (
    <div className="xxs:min-h-full">
      {sidebar && (
        <SidebarSettings>
          <SidebarItem
            icon={ArrowTrendingUpIcon}
            link="/dashboard/settings/account"
          >
            Account
          </SidebarItem>
          <SidebarItem
            icon={BuildingLibraryIcon}
            link="/dashboard/settings/cex"
          >
            CEX
          </SidebarItem>
        </SidebarSettings>
      )}
      {sidebar && (
        <Button
          className={twMerge(
            'xxs:px-2 xxs:py-1  fixed rounded-full xxs:top-[82px] z-20 dark:bg-black-600 xxs:bg-black-50 translate-x-[-50%] transition-all',
            expanded ? 'left-[208px] rotate-180' : 'left-[40px]'
          )}
          onClick={() => setExpanded((e) => !e)}
        >
          <ChevronRightIcon className="w-4 h-4" />
        </Button>
      )}
      <div
        className={
          sidebar
            ? twMerge(
                !expanded ? 'xxs:pl-10 lg:pl-12 ' : 'xxs:pl-10 lg:pl-52 ',
                'transition-all',
                className
              )
            : twMerge('lg:px-0 2xl:px-0 mx-auto', className)
        }
      >
        <div
          className={twMerge(
            'flex justify-between items-center xxs:px-2 lg:px-0',
            !config.isTelegramBrowser && 'xxs:mb-2'
          )}
        >
          {pages ? <Breadcrumbs pages={pages} /> : ''}
          {mode === DexSwitchMode.Cex && (
            <span>
              <div>{topLeft}</div> <div className="align-end">{topRight}</div>
            </span>
          )}
        </div>
        {children}
      </div>
    </div>
  );
};

export default PageTemplate;
